import { useCallback, useRef } from 'react';

export const useResizeScrollable = <T extends HTMLElement>() => {
  const panelRef = useRef<T | null>(null);
  const positionRef = useRef<number | undefined>(undefined);

  const storeScrollPosition = useCallback(() => {
    if (panelRef.current) {
      positionRef.current = panelRef.current.scrollTop;
    }
  }, []);
  const setScrollPosition = useCallback(() => {
    if (panelRef.current && typeof positionRef.current === 'number') {
      panelRef.current.scrollTop = positionRef.current;
    }
  }, []);

  return {
    ref: panelRef,
    setScrollPosition,
    storeScrollPosition,
  };
};
